import {
  createFrontendModule,
  createRouteRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { createPermission } from '@backstage/plugin-permission-common';
import GroupWorkIcon from '@material-ui/icons/GroupWork';
import { TeamsPage } from './TeamsPage';

// routeRef explícito + icon são obrigatórios pra aparecer no menu lateral -
// mesmo motivo documentado em ../users/index.tsx.
export const teamsRouteRef = createRouteRef();

const teamsPage = PageBlueprint.make({
  name: 'teams',
  params: {
    path: '/teams',
    title: 'Times',
    icon: <GroupWorkIcon />,
    routeRef: teamsRouteRef,
    loader: async () => <TeamsPage />,
  },
});

// Mesmo nome do permission object do backend
// (packages/backend/src/modules/permissionPolicy.ts) - ver comentário
// equivalente em ../users/index.tsx sobre por que duplicar em vez de
// importar (sem pacote compartilhado entre app/backend aqui).
export const teamsReadPermission = createPermission({
  name: 'teams.read',
  attributes: { action: 'read' },
});

export const teamsModule = createFrontendModule({
  pluginId: 'app',
  extensions: [teamsPage],
});
